"use strict";
import { atom, onSet } from "nanostores";
import { useEffect } from "react";
const instances = atom(0);
onSet(instances, ({ newValue }) => {
  const oldValue = instances.get();
  if (oldValue === 0 && newValue === 1) {
    const top = `-${window.scrollY}px`;
    const width = `${document.body.offsetWidth}px`;
    document.body.style.position = "fixed";
    document.body.style.top = top;
    document.body.style.width = width;
  }
  if (newValue === 0) {
    const scrollY = document.body.style.top ? Number.parseInt(document.body.style.top, 10) : 0;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo(0, scrollY * -1);
  }
});
const useScrollLock = (isActive) => {
  useEffect(() => {
    if (!isActive) {
      return void 0;
    }
    instances.set(instances.get() + 1);
    return () => {
      instances.set(instances.get() - 1);
    };
  }, [isActive]);
};
export {
  useScrollLock
};
